import * as React from 'react';


export default class Review extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <svg className={this.props.className} viewBox="0 0 140 140">
                <circle className="icon_path" fill="none" stroke="#73AF55" strokeWidth="10" strokeMiterlimit="10" cx="67" cy="67" r="62.1"></circle>
                <polyline className="icon_path" fill="none" stroke="#73AF55" strokeWidth="10" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "></polyline>
            </svg>
        )
    }
}